// Helpers
import clsx from "clsx";
// MUI
import { Box } from "@mui/material";
import { ExpandCollapseAllButtonHeader } from "./ExpandCollapseAllButtonHeader";
// Types
import { CustomGridTreeDataGroupAllHeaderProps } from "@Layouts/components/types";

export function CustomGridTreeDataGroupAllHeader({ topAligned = false, ...props }: Readonly<CustomGridTreeDataGroupAllHeaderProps>) {
	return (
		<Box className={clsx({ relative: true, "-top-[3px]": topAligned, "top-[2px]": !topAligned })}>
			<ExpandCollapseAllButtonHeader {...props} expandedAll />
		</Box>
	);
}
